define('core/extensions/helpers/each',[
    'handlebars',
], function (
    Handlebars
) {
    'use strict';

    return function (context, options) {
        var fn = options.fn;
        var inverse = options.inverse;

        var i = 0;
        var ret = '';
        var data, key, j;

        if (options.data)
            data = Handlebars.createFrame(options.data);

        if (context && typeof context === 'object') {
            if (Object.prototype.toString.call(context) === '[object Array]') {
                for (j = context.length; i < j; i++) {
                    if (data) {
                        data.index = i;
                        data.length = context.length; // added this line to original handlebars helper
                    }
                    ret += fn(context[i], { data: data });
                }
            } else {
                for (key in context) {
                    if (context.hasOwnProperty(key)) {
                        if (data)
                            data.key = key;

                        ret += fn(context[key], { data: data });
                        i += 1;
                    }
                }
            }
        }

        if (i === 0)
            ret = inverse(this);

        return ret;
    };
});

